<template>
    <div class="grid fixed fixed-max-sm xs-grid-cols-1 sm-grid-cols-2 md-grid-cols-3 gap-3" v-if="linksWithUrls && linksWithUrls.length">
        <div class="wrap" v-if="title || subTitle">
            <h2 v-if="title" class="f3 text-capitalize text-bold">
                {{ title }}
            </h2>
            <div v-if="subTitle" v-html="subTitle"></div>
        </div>
        <div :href="glb.appUrl + link[nameForUrl]" v-for="(link, index) in linksWithUrls" :key="index" class="inline large corner bg-default" v-show="index > 7 ? showAll : true">
            <div class="vertical center flex">
                <div class="singleline text-bold">
                    <a :href="glb.appUrl + link[nameForUrl]" v-ga:click>
                        {{ link.displayName }}
                        <span class="f7" v-if="link.listingCount">({{ link.listingCount }})</span>
                        <span>{{ displaySuffix }}</span>
                    </a>
                    <a v-if="link.newNameForUrl" :href=" glb.appUrl + link.newNameForUrl" class="link f7" v-ga:click> (New) </a>
                    <a v-if="link.luxuryHomesUrl" :href=" glb.appUrl + link.luxuryHomesUrl" class="link f7" v-ga:click> (Luxury) </a>
                </div>
                <a v-if="link.zipcodeUrl" :href=" glb.appUrl + link.zipcodeUrl" class="link text-bold singleline" v-ga:click> {{ link.abbreviation }} ZIP Codes </a>
                <a v-if="link.neighborhoodUrl" :href=" glb.appUrl + link.neighborhoodUrl" class="link text-bold singleline" v-ga:click> {{ link.abbreviation }} Neighborhoods </a>
            </div>
        </div>
        <div class="wrap" v-if="linksWithUrls.length>8">
            <a @click="toggle" class="show-hide-toggle" :class="showAll ? 'shown' : ''" role="button">{{ showAll ? 'Show Less' : 'Show All' }} <i></i></a>
        </div>
        <slot></slot>
    </div>
</template>

<script src="./mvt-listlinks.js"></script>
